module.exports = __webpack_public_path__ + "static/img/incheon-ag-final-report.d227011.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/incheon-ag-final-report.jpg
// module id = Ux3L
// module chunks = 0